import { Api } from "@core/api/api";
import { Page } from "@utils/page";
import { Currency, CurrencyCode, CurrencyConversion } from "./currency";

const CURRENCY_URL = "/currencies";

export class CurrencyApi {
	constructor(private readonly api: Api) {}

	async getCurrency(id: string): Promise<Currency> {
		const result = await this.api.get<CurrencyDto>(`${CurrencyApi}/${id}`);

		return currencyFromDto(result.data);
	}

	async getCurrencies(): Promise<Page<Currency>> {
		const result = await this.api.get<Page<CurrencyDto>>(`${CURRENCY_URL}`);

		return { ...result.data, content: result.data.content.map(currencyFromDto) };
	}

	async getConversion(baseCurrency: CurrencyCode, value: number): Promise<Partial<CurrencyConversion>> {
		const result = await this.api.get<CurrencyConversion>(`${CURRENCY_URL}/convert/${baseCurrency}/${value}`);
		return result.data;
	}
}

interface CurrencyDto extends Omit<Currency, "lastUpdateDate"> {
	lastUpdateDate: string;
}

const currencyFromDto = (dto: CurrencyDto): Currency => {
	return {
		...dto,
		lastUpdateDate: new Date(dto.lastUpdateDate),
	};
};
